import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

const Icon = (props) => {
  const {glyph, color, iconSize, className} = props;
  const classes = classNames({
    icon: true,
    [className]: Boolean(className),
    [`icon-${glyph}`]: Boolean(glyph),
    [`icon_${color}`]: Boolean(color),
  });
  const style = {
    fontSize: `${iconSize}px`,
  };

  return (
    <i
      style={style}
      aria-hidden="true"
      className={classes}
    />
  );
};

Icon.propTypes = {
  glyph: PropTypes.string.isRequired,
  color: PropTypes.string,
  iconSize: PropTypes.string,
  className: PropTypes.string,
};

Icon.defaultProps = {
  color: '',
  iconSize: '14',
  className: '',
};

export default Icon;
